import {ChangeDetectionStrategy, Component, inject, OnInit, output} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SelectData} from "../../../../../../../../core/types/records-table.types";
import {defaultRecordTableParams} from "../../../../../../../../core/models/default-record-table-params";
import {PcRatingService} from "../../services/pc-rating.service";
import {DateRange, HandleFilterSelectParams} from "../../types/pc-rating-modal.types";
import {defaultDateRange} from "../../configs/pc-rating-modal-config";
import {customDateProvider} from "../../../../../../../../core/locale/providers/custom-date.provider";
import {MatFormField, MatInput, MatLabel, MatSuffix} from "@angular/material/input";
import {DateInputDirective} from "../../../../../../../../shared/directives/date-input.directive";
import {
  MatDateRangeInput,
  MatDateRangePicker,
  MatDatepickerToggle,
  MatDatepickerToggleIcon,
  MatEndDate,
  MatStartDate
} from "@angular/material/datepicker";
import {MatIcon} from "@angular/material/icon";
import {
  CustomMatSelectComponent
} from "../../../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";

@Component({
  selector: 'app-pc-rating-filters',
  standalone: true,
  imports: [
    MatFormField,
    MatLabel,
    MatDateRangeInput,
    ReactiveFormsModule,
    MatInput,
    DateInputDirective,
    MatEndDate,
    MatDatepickerToggle,
    MatDatepickerToggleIcon,
    MatStartDate,
    MatSuffix,
    MatIcon,
    MatDateRangePicker,
    CustomMatSelectComponent
  ],
  templateUrl: './pc-rating-filters.component.html',
  styleUrl: './pc-rating-filters.component.scss',
  providers: [ ...customDateProvider ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PcRatingFiltersComponent implements OnInit {
  handleFilterSelect = output<HandleFilterSelectParams>();
  handleFilterDate = output<DateRange>();

  private pcRatingService: PcRatingService = inject(PcRatingService);

  public rangeForm = new FormGroup({
    dateFrom: new FormControl(''),
    dateTo: new FormControl('')
  });
  public marketplace: SelectData | null = null;
  public article: SelectData | null = null;
  public marketplacesSelectData: Array<SelectData> = [];
  public articlesSelectData: Array<SelectData> = [];

  public async ngOnInit(): Promise<void> {
    await this.getMeta();
  }

  public handleDateRangeChange(dateRangeStart: string | null, dateRangeEnd: string | null): void {
    this.getData(dateRangeStart, dateRangeEnd);
  }

  public clearDateRange(): void {
    this.rangeForm.reset();
    this.handleDateRangeChange(null, null);
  }

  public handleSelectChange(value: string, key: string): void {
    this.handleFilterSelect.emit({
      key: key,
      value: String(value)
    });
  }

  private getData(dateRangeStart: string | null, dateRangeEnd: string | null): void {
    if (!this.rangeForm.value.dateFrom || !this.rangeForm.value.dateTo) {
      this.handleFilterDate.emit(defaultDateRange);
      return;
    }

    const dateRange: DateRange = {
      dateFrom: dateRangeStart,
      dateTo: dateRangeEnd
    };

    this.handleFilterDate.emit(dateRange);
  }

  private async getMeta(): Promise<void> {
    const meta = await this.pcRatingService.getMeta().catch(() => defaultRecordTableParams);
    this.marketplacesSelectData = meta.fields.find(i => i.key === 'channelType')?.metaSelectKeyList || [];
    this.articlesSelectData = meta.fields.find(i => i.key === 'article')?.metaSelectKeyList || [];
  }
}
